import React from "react";
import { Assets } from "../../constant/images";
import { NavLink, useLocation } from "react-router-dom";
import { PlusIcon } from "../../utils/svg";
const BuyerAddress = () => {
  const location = useLocation();
  const path = location.pathname.split("/")[1];
  return (
    <>
      <div className="main-buyer-address">
        <div className="top-heading-edit-div">
          <div className="heading-div">
            <h4>Address</h4>
          </div>
          {/* <div className="edit-div">
            <NavLink to="/address/buyer-address-edit" className={path === "address" && "active"}>Edit</NavLink>
          </div> */}
        </div>

        <div className="buyer-account-content">
          <div className="buyer-avatar">
            <p>
              The following addresses will be used on the checkout page by
              default.
            </p>
          </div>
          <div className="shipping-addnew-heading">
            <div className="shipping-heading">
              <h2>Shipping Address</h2>
            </div>
            <div className="add-new-div">
              <div className="svg-div">
                <PlusIcon />
              </div>
              <div className="add-new-heading">
                <NavLink
                  to="/address/buyer-address-edit"
                  className={path === "address" && "active"}
                >
                  Add New
                </NavLink>
              </div>
            </div>
          </div>
          <div className="buyer-cards">
          <div className="buyer-info">
            <div className="address-info">
              <ul>
                <li>
                  <span>Street Name:</span>
                  <span>217 E Bondo Street, New York</span>
                </li>
                <li>
                  <span>City:</span> <span>California</span>
                </li>
                <li>
                  <span>ZIP Code</span> <span>NY 10011</span>
                </li>
              </ul>
            </div>
            <div className="edit-button-div">
              <NavLink
                to="/address/buyer-address-edit"
                className={path === "address" && "active"}
              >
                Edit
              </NavLink>
            </div>
          </div>
          <div className="buyer-info">
            <div className="address-info">
              <ul>
                <li>
                  <span>Street Name:</span>
                  <span>217 E Bondo Street, New York</span>
                </li>
                <li>
                  <span>City:</span> <span>California</span>
                </li>
                <li>
                  <span>ZIP Code</span> <span>NY 10011</span>
                </li>
              </ul>
            </div>
            <div className="edit-button-div">
              <NavLink
                to="/address/buyer-address-edit"
                className={path === "address" && "active"}
              >
                Edit
              </NavLink>
            </div>
          </div>
          <div className="buyer-info">
            <div className="address-info">
              <ul>
                <li>
                  <span>Street Name:</span>
                  <span>217 E Bondo Street, New York</span>
                </li>
                <li>
                  <span>City:</span> <span>California</span>
                </li>
                <li>
                  <span>ZIP Code</span> <span>NY 10011</span>
                </li>
              </ul>
            </div>
            <div className="edit-button-div">
              <NavLink
                to="/address/buyer-address-edit"
                className={path === "address" && "active"}
              >
                Edit
              </NavLink>
            </div>
          </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default BuyerAddress;
